import BranchApi from 'api/branch';
import DealerApi from 'api/dealer';
import events from 'lib/events';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import OptOutEmails from './optOutEmails';
import OutboundEmails from './outboundEmails/outboundEmails';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import waterTesterApi from 'api/waterTester';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'ui/helpers/performanceFile';
import {intlShape, injectIntl} from 'react-intl';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

const render = (container, params) => {
  console.info('[UI.page.reports.communications] rendering page');
  ReactDOM.render(<IntlWrapper><CommunicationsReport subPageName={params.subPage} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports.communications] register route');
router.rr.add([{path: 'reports/communications/:subPage', handler: routeUtils.requireAdmin(render)}]);

class _CommunicationsReport extends Component {
  static propTypes = {
    subPageName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      user: session.getUser(),
      loaded: false,
    };
  }
  componentWillMount() {
    const apis = [];

    apis.push(BranchApi.getMyBranches());
    apis.push(DealerApi.getDealer(this.state.user.dealerId));
    apis.push(waterTesterApi.getWaterTesters());
    Promise.all(apis)
      .then(([branches, dealer, testers]) => {
        console.log('branches', branches);
        console.log('dealer', dealer);
        this.setState({
          loaded: true,
          dealer: dealer,
          branches: branches,
          testers: testers,
        });
      }).catch(err => {
        console.log('error', err);
      });
  }

  checkPOSPermission() {
    const {user, dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    } else if (user.isDealerAdmin) {
      return true;
    } else if (user.isAdmin && dealer.managerDetailedReporting) {
      return true;
    } else if (user.isTestStation && dealer.testerDetailedReporting) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const {subPageName} = this.props;
    const {branches,testers} = this.state;
    let {formatMessage} = this.props.intl;
    const subPages = {
      'outbound-emails': {name: formatMessage({id: 'reports.communications.outbound.emails'}), element: <OutboundEmails branches={branches} />},
      'optout-emails': {name: formatMessage({id: 'reports.communications.optout.emails'}), element: <OptOutEmails branches={branches} />},
    };
    const subPagesTabs = Object.keys(subPages)
      .map(sp => <a key={sp} className={subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
        href={'#reports/communications/' + sp}>{subPages[sp].name}
      </a>);
    const subPage = subPages[subPageName].element;

    return (
      <div className='container'>
        <div id='page-reports' >
          <div className='nav-tabs'>
            <Header mainTitle={formatMessage({id: 'reports.title'})} subTitle={formatMessage({id: 'reports.communications'})} mainTitleReturn='reports'/>
          </div>
          <nav className='navigation-tabs'>
            {subPagesTabs}
          </nav>
          <Loader loaded={this.state.loaded}>
            <div className='report-details'>
              {subPage}
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

const CommunicationsReport = injectIntl(bindLocaleUpdate(connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_CommunicationsReport)));

export default CommunicationsReport;
